module.exports = __webpack_public_path__ + "img/sorento-21.ea44c122.png";